module.exports = __webpack_public_path__ + "img/jbt3411_76-1999.prt.e3f40d81.jpg";